/* eslint-disable import/prefer-default-export */
import icon from '../assets/symbiote-favicon.png';
import Image from '../assets/symbiotelabphotoshop.png';

export const symbioteConfig = {
  title: 'Symbiote',
  catalog: 'partner',
  partner: 'symbiote',
  origin: 'https://www.symbiote.com',
  host: 'seating.symbiote.com',
  logo: 'https://ecomseating.s3.amazonaws.com/images/other/symbiote-logo.png',
  logoURL: 'https://ecomseating.s3.amazonaws.com/images/other/symbiote-logo.png',
  buildAChair: 'symbiote',
  businessInfo: '300 N. Centennial Street, Zeeland, MI 49464',
  headerTheme: '#FFFFFF',
  secondaryTheme: '#E11282',
  footerTheme: '#FFFFFF',
  headerTextColor: '#4b4f54',
  footerTextColor: '#4b4f54',
  buttonTextColor: '#FFFFFF',
  bannerColor: '#62b3e4',
  extraAttributes: {
    trackId: 'G-S6ZCQNEGRY',
    popup: true,
    icon,
    colorOverride: {
      buttonColor: '#e11282',
      buttonColorDark: '#e11282',
      buttonTextDark: '#FFF',
      buttonText: '#FFFFFF',
      titleLight: '#24315a',
      titleDark: '#62b3e4',
    },
    Image,
  },
};
